import React, { useEffect, useRef } from "react";
import { Header } from "../header";
import { ReactComponent as Banner } from "../../../src/assets/images/why_thy-01.svg";
import { Footer } from "../footer";
import UpAnimation from "../../../src/components/UpAnimation";
import "./why-thy.css"
export const WhyThy = () => {
    const headerRef:any=useRef();
    useEffect(()=>{
        headerRef?.current?.scrollIntoView({ behavior: 'smooth' });
    },[])
    return (
        <div className="why-thy-container" ref={headerRef}>
            <Header />
            <div style={{display:"flex",alignItems:"center",justifyContent:"center",width:"80%",flexDirection:"column"}}>
               <div className="why-thy-title" >WHY THY?</div>
               <div className="divider" ></div>
                 <div className="why-thy-content">
               <UpAnimation>
                <div className="why-thy-description">
                    <p>Our journey started in the year of 2009. After years of expertise in Designing &
                        Printing industry, we realized that it was near impossible for the average
                        people to find a quick solution for their designing and printing needs.
                        Traditional Designing & Printing services were too complicated,
                        time-consuming & expensive to manage.</p>
                </div>
                </UpAnimation>
            </div>
               </div>
          
            <div className="why-thy-banner-container">
                <Banner />
            </div>
            <div className="why-thy-details">
                <UpAnimation>
                <div className="why-thy-details-box">
                    <p>We created a business solution while keeping the user's perspective in mind.
                        We wanted to offer a platform that would require no design and print
                        experience. We keep it simple, so our team can focus on creating fantastic
                        Designs & Prints that reflect their brand. Showcase your brand uniqueness or
                        products right away.</p>

                    <p>
                        Today, we're proud to provide an innovative & complete solution to our
                        customers for Graphic Designing, Printing, Binding, Educational Kits,
                        Customised Gifts and Product Sales. We have vast experience. Our technically
                        and well-qualified team is providing quick and consistent business solutions
                        based on your needs.
                    </p>

                </div>
                </UpAnimation>
            </div>
            <Footer />
        </div>
    )
}